import colors from 'styles/sass-variables.module.scss';

const wrapperStyles: Record<string, string> = {
  borderRadius: '8px',
  backgroundColor: colors.white,
  padding: '24px',
  boxSizing: 'border-box',
};

export default wrapperStyles;
